import _ from 'underscore';
import queryString from 'query-string';
import {
  createRequestContract,
  createResponseContract,

  requestVerbs,
  responseTypes,
} from '@bingads-webui-react/overreact';

import { edm } from '../../../environment/edm';
import { schema } from '../../../environment/schema';
import { parseSearch, getDefaultHeaderObj } from '../../../request-contract-helper';

function odataUrlFactory(params) {
  const { variables } = params;

  const {
    locator,
    id,
  } = variables;

  const { descriptor } = locator;
  const { cid, aid } = descriptor;
  const entity = edm
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns['Default.GridData'];
  const search = {
    top: 5,
    skip: 0,
    filter: {
      where: `Id eq ${id}`,
    },
    select: ['Id', 'Name', 'Status', 'PerformanceMetrics/Clicks', 'PerformanceMetrics/Impressions', 'PerformanceMetrics/Spend'],
    count: true,
  };

  const parsedSearch = {
    ...parseSearch(search, entity),
    includesmartcampaign: true,
  };

  const searchCompact = _.omit(parsedSearch, x => _.isNull(x) || _.isUndefined(x));
  const searchString = _.isEmpty(searchCompact) ? '' : `?${queryString.stringify(searchCompact)}`;

  return `${entity.path}${searchString}`;
}

function odataHeaderFactory() {
  return getDefaultHeaderObj();
}

function odataPayloadFactory(params) {
  const { variables } = params;
  const {
    startDate,
    endDate,
  } = variables;

  let StartDate = startDate;
  let EndDate = endDate;
  if (!StartDate) {
    const yesterday = new Date(Date.now() - 864e5);
    [StartDate] = yesterday.toISOString().split('T');
  }
  if (!EndDate) {
    EndDate = StartDate;
  }

  return {
    gridDataParameters: {
      DateRange: {
        StartDate,
        EndDate,
      },
    },
  };
}

export const fetchRequestContract = createRequestContract({
  schema,
  dataPath: 'customer:account:campaign',
  verb: requestVerbs.POST,
  uriFactoryFn: odataUrlFactory,
  headerFactoryFn: odataHeaderFactory,
  payloadFactoryFn: odataPayloadFactory,
  keySelector: campaign => campaign.Id,
  parentKeySelector: variables => variables.locator.descriptor.aid,
});

export const fetchResponseContract = createResponseContract({
  requestContract: fetchRequestContract,
  responseType: responseTypes.ENTITY,
  keySelector: campaign => campaign.Id,
  processorFn: response => response.value[0],
});
